import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import BreakingList from "./components/BreakingList";
import DirectionGrid from "./components/DirectionGrid";
import FeatureGrid from "./components/FeatureGrid";
import ArchiveTimeline from "./components/ArchiveTimeline";
import ResourceList from "./components/ResourceList";
import TipBand from "./components/TipBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="w-full bg-background-50">
      <Navbar />
      <Hero />
      <BreakingList />
      <DirectionGrid />
      <FeatureGrid />
      <ArchiveTimeline />
      <ResourceList />
      <TipBand />
      <Footer />
    </main>
  );
}